<template>
  <loading v-if="pageStatus === 'loading'" />
  <not-found v-else-if="pageStatus === 'error'" />
  <not-auth v-else-if="$status.cycleParameters === 'NOT_AUTHORIZED'"></not-auth>
  <div v-else>
    <!-- Kütle Debisi Sınır Şartları -->
    <div class="u-border u-radius-g u-margin-bottom">
      <h5 class="u-padding-xsmall">
        {{ $t("cycleParameters.massFlowLimits") }}
      </h5>
      <div class="u-padding-xsmall">
        <div class="row u-margin-0">
          <div class="es-xs-12 es-sm-6">
            <BaseInput
              block
              :label="$t('cycleParameters.stage1UpperLimit')"
              suffix="kg/h"
              size="sm"
              v-model="form.stage1UpperLimit"
            />
          </div>
          <div class="es-xs-12 es-sm-6">
            <BaseInput
              block
              :label="$t('cycleParameters.stage2LowerLimit')"
              suffix="kg/h"
              size="sm"
              v-model="form.stage2LowerLimit"
            />
          </div>
          <div class="es-xs-12 es-sm-6">
            <BaseInput
              block
              :label="$t('cycleParameters.stage2UpperLimit')"
              suffix="kg/h"
              size="sm"
              v-model="form.stage2UpperLimit"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Döngü Sıcaklık Artış Miktarları -->
    <div class="u-border u-radius-g u-margin-bottom">
      <h5 class="u-padding-xsmall">
        {{ $t("cycleParameters.cycleTemperatureIncrements") }}
      </h5>
      <div class="u-padding-xsmall">
        <div class="row u-margin-0">
          <div class="es-xs-12 es-sm-6">
            <BaseInput
              block
              :label="$t('cycleParameters.stage1TemperatureIncrease')"
              suffix="°C"
              size="sm"
              v-model="form.stage1TemperatureIncrease"
            />
          </div>
          <div class="es-xs-12 es-sm-6">
            <BaseInput
              block
              :label="$t('cycleParameters.stage2TemperatureIncrease')"
              suffix="°C"
              size="sm"
              v-model="form.stage2TemperatureIncrease"
            />
          </div>
          <div class="es-xs-12 es-sm-6">
            <BaseInput
              block
              :label="$t('cycleParameters.stage3TemperatureIncrease')"
              suffix="°C"
              size="sm"
              v-model="form.stage3TemperatureIncrease"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Döngü Sayısı -->
    <div class="u-border u-radius-g u-margin-bottom">
      <h5 class="u-padding-xsmall">{{ $t("cycleParameters.cycleCount") }}</h5>
      <div class="u-padding-xsmall">
        <div class="row u-margin-0">
          <div class="es-xs-12 es-sm-6">
            <BaseInput
              block
              :label="$t('cycleParameters.stage1CircleCount')"
              size="sm"
              v-model="form.stage1CircleCount"
            />
          </div>
          <div class="es-xs-12 es-sm-6">
            <BaseInput
              block
              :label="$t('cycleParameters.stage2CircleCount')"
              size="sm"
              v-model="form.stage2CircleCount"
            />
          </div>
          <div class="es-xs-12 es-sm-6">
            <BaseInput
              block
              :label="$t('cycleParameters.stage3CircleCount')"
              size="sm"
              v-model="form.stage3CircleCount"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Döngü Koşulu -->
    <div class="u-border u-radius-g u-margin-bottom">
      <h5 class="u-padding-xsmall">
        {{ $t("cycleParameters.cycleCondition") }}
      </h5>
      <div class="u-padding-xsmall">
        <div class="row u-margin-0">
          <div class="es-xs-12 es-sm-6">
            <BaseInput
              block
              :label="$t('cycleParameters.evapAbsoluteFlowDifference')"
              suffix="kg/h"
              size="sm"
              v-model="form.evapAbsoluteFlowDifference"
            />
          </div>
          <div class="es-xs-12 es-sm-6">
            <BaseInput
              block
              :label="$t('cycleParameters.condAbsoluteFlowDifference')"
              suffix="kg/h"
              size="sm"
              v-model="form.condAbsoluteFlowDifference"
            />
          </div>
          <div class="es-xs-12 es-sm-6">
            <BaseInput
              block
              :label="$t('cycleParameters.circleCount')"
              size="sm"
              v-model="form.circleCount"
            />
          </div>
          <div class="es-xs-12 es-sm-6">
            <BaseInput
              block
              :label="$t('cycleParameters.evaporatorApproachTemp')"
              suffix="°C"
              size="sm"
              v-model="form.evaporatorApproachTemp"
            />
          </div>
          <div class="es-xs-12 es-sm-6">
            <BaseInput
              block
              :label="$t('cycleParameters.condenserApproachTemp')"
              suffix="°C"
              size="sm"
              v-model="form.condenserApproachTemp"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="u-border u-radius-g u-margin-bottom u-padding-xsmall">
      <h6 class="u-margin-bottom-none">
        <strong>
          <i class="icofont-save u-font-size-xsmall u-margin-right-xsmall"></i>
          {{ $t("cycleParameters.saveTitle") }}
        </strong>
      </h6>
      <p class="u-margin-bottom u-color-muted">
        <small>
          {{ $t("cycleParameters.saveDescription") }}
        </small>
      </p>
      <Button variant="primary" block @click="updateCycleParameters">
        {{ $t("common.save") }}
      </Button>
    </div>
  </div>
</template>

<script>
import BaseInput from "@/components/Base/Inputs/BaseInput.vue";
import Requests from "@/services/Requests";
import Loading from "../Base/Loading/Loading.vue";
import NotFound from "../Base/NotFound.vue";
import Button from "../Base/Button.vue";

export default {
  components: {
    BaseInput,
    Loading,
    NotFound,
    Button,
  },
  data() {
    return {
      pageStatus: "loading",
      form: {
        // Kütle Debisi Sınır Şartları
        stage1UpperLimit: 51,
        stage2LowerLimit: 11,
        stage2UpperLimit: 50,

        // Döngü Sıcaklık Artış Miktarları
        stage1TemperatureIncrease: 1,
        stage2TemperatureIncrease: 0.1,
        stage3TemperatureIncrease: 0.01,

        // Döngü Sayısı
        stage1CircleCount: 20,
        stage2CircleCount: 20,
        stage3CircleCount: 20,

        // Döngü Koşulu
        evapAbsoluteFlowDifference: 19,
        condAbsoluteFlowDifference: 19,
        circleCount: 50,
        evaporatorApproachTemp: 20,
        condenserApproachTemp: 15,
      },
      cycleParameters: null,
    };
  },
  methods: {
    async getCycleParameters() {
      this.pageStatus = "loading";
      const response = await Requests.CycleParameters.GetAll();
      this.$status.cycleParameters = response.message;
      if (response.message === "OK") {
        this.form = response.data;
        this.cycleParameters = { ...response.data };
        this.pageStatus = "loaded";
      } else {
        this.pageStatus = "error";
      }
    },
    checkUpdatedValues() {
      const values = [];
      if (this.cycleParameters) {
        Object.keys(this.cycleParameters).forEach((key) => {
          console.log(this.cycleParameters[key], this.form[key]);

          if (this.cycleParameters[key] !== this.form[key]) {
            values.push({ key, value: this.form[key] });
          }
        });
      }
      return values;
    },
    async updateCycleParameters(e, loading) {
      const values = this.checkUpdatedValues();
      console.log(values, "vale");

      if (values.length > 0) {
        loading(true);
        const response = await Requests.CycleParameters.Create(values);
        if (response.message === "OK") {
          this.$store.dispatch("SET_ACTION_MODAL", {
            isLoading: false,
            status: true,
            message: this.$t("cycleParameters.saved"),
            variant: "success",
            duration: 2500,
          });

          this.getCycleParameters();
        } else {
          this.$store.dispatch("SET_ACTION_MODAL", {
            isLoading: false,
            status: true,
            message: this.$t("cycleParameters.error"),
            variant: "danger",
            duration: 2500,
          });
        }
        loading(false);
      }
    },
  },
  mounted() {
    this.getCycleParameters();
  },
};
</script>

<style></style>
